"use client"

import type { EnemyVariant } from "@/types/enemy.types"
import { ENEMY_SPRITESHEET, ENEMY_SPRITE_COUNT, ENEMY_SPRITE_INDEX } from "@/components/game-ui/enemy-sprite-index"
import { spriteStripStyle } from "@/components/game-ui/sprite-strip"



interface NewEnemyButtonProps {
  enemyId: string
  variant: EnemyVariant
  onClick: () => void
  /** Distance from the window edge to the game area, so the badge stays inside
   *  the pillarbox instead of floating over the background art. */
  canvasSideOffset?: number
}

export const NewEnemyButton = ({ enemyId, variant, onClick, canvasSideOffset = 0 }: NewEnemyButtonProps) => {
  const spriteIndex = ENEMY_SPRITE_INDEX[enemyId]
  const hasSprite = spriteIndex !== undefined

  // Badge colors based on variant
  const badgeColor =
    variant === "unique"
      ? "#dc2626" // Red for boss/unique
      : variant === "elite"
      ? "#a855f7" // Purple for elite
      : "#f59e0b" // Gold for regular

  const borderColor =
    variant === "unique" ? "#991b1b" : variant === "elite" ? "#7e22ce" : "#d97706"

  return (
    <div
      className="fixed top-1/2 -translate-y-1/2 z-50 animate-in slide-in-from-left duration-500"
      style={{ left: `${canvasSideOffset + 16}px` }}
    >
      {/* Tap here callout */}
      <div
        className="absolute -top-8 left-1/2 -translate-x-1/2 whitespace-nowrap px-3 py-1 rounded-lg font-bold italic text-sm shadow-lg animate-pulse"
        style={{
          background: "linear-gradient(to bottom, #f5e6d3, #e8d5b7)",
          border: "2px solid #8b7355",
          color: "#2d1810",
        }}
      >
        TAP HERE!
      </div>

      {/* Circular badge button */}
      <button
        onClick={onClick}
        className="relative w-20 h-20 rounded-full flex items-center justify-center shadow-2xl transition-all hover:scale-110 active:scale-95 animate-pulse"
        style={{
          backgroundColor: badgeColor,
          border: `4px solid ${borderColor}`,
          boxShadow: `0 0 20px ${badgeColor}80, 0 8px 16px rgba(0,0,0,0.4)`,
        }}
      >
        {/* Enemy sprite */}
        {hasSprite ? (
          <div
            className="w-14 h-14 rounded-full overflow-hidden"
            style={{
              backgroundImage: `url(${ENEMY_SPRITESHEET})`,
              ...spriteStripStyle(spriteIndex, ENEMY_SPRITE_COUNT),
            }}
          />
        ) : (
          <div className="text-white text-2xl font-bold">?</div>
        )}
      </button>
    </div>
  )
}
